import { AudioLines } from 'lucide-react'
import { emojiImageUrl } from '@/lib/markdown'

interface Props {
  id: string | null | undefined
  name: string | null | undefined
  size?: number
  className?: string | undefined
}

/** Эмодзи звука панели: картинка эмодзи сервера, обычный эмодзи или значок звука, если эмодзи нет. */
export function SoundEmoji({ id, name, size = 20, className }: Props) {
  if (id) return <img className={className} src={emojiImageUrl(id)} alt="" width={size} height={size} draggable={false} />
  if (name) return <span className={className} style={{ fontSize: Math.round(size * 0.9), lineHeight: 1 }} aria-hidden="true">{name}</span>
  return <AudioLines className={className} size={Math.round(size * 0.8)} aria-hidden="true" />
}
